import React from 'react';
import { useSelector } from 'react-redux';

import LaunchpadWidgetWrapper from '../../LaunchpadWidgetWrapper';
import '../Widgets.scss';



interface BannerWidgetProps {
	widgetDetails?: any;
	editMode?: boolean;
	widgets?: any[];
	setWidgets?: (widgets: any[]) => void;
	setSnackbar?: (snackbar: any) => void;
	t: (key: string) => string;
	widgetCustomizationData?: {
		bannerImage?: string;
		bannerHoverText?: string;
		bannerHoverUrl?: string;
	};
	setWidgetCustomizationData?: (data: any) => void;
	widgetFinishStatus?: any;
	setWidgetFinishStatus?: (status: any) => void;
	editModalInputFields?: any;
	setEditModalInputFields?: (fields: any) => void;
	bannerConfig?: any;
	bannerImageUrl?: string;
	setBannerImageUrl?: (url: any) => void;
	isLoading?: boolean;
	selectLaunchpadSettingsData?: any;
	handleLinkClick?: (e: React.MouseEvent, link: string) => void;
}

const BannerWidget: React.FC<BannerWidgetProps> = ({
	widgetDetails = [],
	editMode = false,
	widgets = [],
	setWidgets = () => {},
	setSnackbar = () => {},
	t,
	widgetCustomizationData,
	setWidgetCustomizationData,
	widgetFinishStatus,
	setWidgetFinishStatus,
	editModalInputFields,
	setEditModalInputFields = () => {},
	bannerConfig,
	bannerImageUrl,
	setBannerImageUrl,
	isLoading,
	selectLaunchpadSettingsData,
	handleLinkClick = () => {},
}) => {
	const launchpadSettingsData = useSelector(selectLaunchpadSettingsData) as any;

	return (
		<LaunchpadWidgetWrapper
			{...{
				bannerConfig,
				bannerImageUrl,
				editModalInputFields,
				editMode,
				hideHeader: true,
				isBannerWidget: true,
				isLoading,
				isTitleBlock: true,
				selectLaunchpadSettingsData,
				setBannerImageUrl,
				setEditModalInputFields,
				setSnackbar,
				setWidgetCustomizationData,
				setWidgetFinishStatus,
				setWidgets,
				t,
				widgetCustomizationData,
				widgetDetails,
				widgetFinishStatus,
				widgets,
			} as any}
		>
			{isLoading ? (
				<div className="banner-skeleton-container position-relative w-100 rounded-2 bg-light">
					<div className="skeleton-circle position-absolute rounded-circle bg-secondary opacity-25" />
					<div className="d-flex justify-content-center align-items-center h-100">
						<svg
							fill="none"
							height="69"
							viewBox="0 0 246 69"
							width="246"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M0.5 68.3701L37.8897 8.81188C40.9921 3.87212 46.3635 0.950436 52.1467 1.00064C57.98 1.05084 63.2612 4.05285 66.2833 9.03277L90.0181 48.2195C92.0663 51.6131 95.6507 53.4605 99.6065 53.1994C103.562 52.9283 106.856 50.599 108.432 46.9645L113.07 36.2516C115.731 30.1271 121.524 26.2717 128.201 26.2115C128.261 26.2115 128.321 26.2115 128.382 26.2115C134.978 26.2115 140.771 29.9263 143.532 35.9404L155.631 62.3059C157.317 65.9906 161.022 68.3601 165.078 68.3601H245"
								stroke="#D1D2D4"
								strokeLinecap="round"
								strokeWidth="1.00402"
							/>
						</svg>
					</div>
				</div>
			) : (
				<div className="banner-container position-relative w-100">
					<div
						className="banner-image-background"
						style={{
							backgroundImage: `url(${widgetFinishStatus?.[widgetDetails?.id] ? widgetCustomizationData?.bannerImage : bannerConfig?.bannerImage})`,
						}}
					/>
					<img
						alt="Banner"
						className="banner-image w-100 h-100 rounded-2"
						crossOrigin="anonymous"
						loading="lazy"
						src={
							widgetFinishStatus?.[widgetDetails?.id]
								? widgetCustomizationData?.bannerImage
								: bannerConfig?.bannerImage
						}
					/>
					<div className="banner-overlay position-absolute top-0 start-0 end-0 bottom-0 w-100 h-100 rounded-2 custom-overlay">
						<div
							className="banner-button position-absolute cursor-pointer top-50 start-50 translate-middle rounded-1 border border-primary bg-white d-flex align-items-center justify-content-center"
							onClick={(e) =>
								handleLinkClick(
									e,
									widgetFinishStatus?.[widgetDetails?.id]
										? widgetCustomizationData?.bannerHoverUrl
										: bannerConfig?.bannerHoverUrl || '',
								)
							}
						>
							<a
								className="banner-link fw-bold text-decoration-none text-center d-inline-block"
								href="#"
								rel="noopener noreferrer"
								style={{
									color:
										launchpadSettingsData?.drawerThemeSettings?.iconColor ||
										'#1571F0',
									width: 'fit-content',
								}}
								target="_blank"
							>
								{widgetFinishStatus?.[widgetDetails?.id]
									? widgetCustomizationData?.bannerHoverText
									: bannerConfig?.bannerHoverText}
							</a>
						</div>
					</div>
				</div>
			)}
		</LaunchpadWidgetWrapper>
	);
};

export default BannerWidget;
